import { useState } from "react"
import isEmpty from "lodash/isEmpty"
import { ReactSVG } from "react-svg"
import getContentUrl from "utils-lib/getContentUrl"
import { handleEnterPress } from "utils-lib/handleEnterPress"
import { handleEscapePress } from "utils-lib/handleEscapePress"

const FooterItem = ({
  footerSubSection,
  column,
  updateFooterSubview = () => {},
}) => {
  const isSelected = footerSubSection === column.columnHeading
  const [isFocused, setIsFocused] = useState(false)

  const updateFooterSection = () => {
    updateFooterSubview(column.columnHeading)
  }

  const handleKeyPress = (shouldUpdate = false) => {
    if (shouldUpdate) {
      updateFooterSection()
    }
  }

  const focusStyles = {
    textDecoration: "underline",
    textDecorationColor: "white",
  }

  return (
    <div
      className="bottomNavItems border-bottom-white d-flex justify-content-between align-items-center pb-3"
      onClick={updateFooterSection}
      onKeyDown={(e) => {
        handleEnterPress(e, () => {
          handleKeyPress(true)
        })
        handleEscapePress(e, () => {
          handleKeyPress(isSelected)
        })
      }}
      data-testid="FooterItem"
      tabIndex="0"
      role="button"
      aria-label={column.columnHeading}
      aria-expanded={isSelected}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      style={isFocused ? focusStyles : {}}
    >
      <div
        className="menu-item text-white d-flex align-items-center maax-font-weight-bold"
        data-testid="FooterItem-columnHeading"
      >
        {column.columnHeading}
      </div>
      {!isEmpty(column.quickLinks) && (
        <span className="wm-cursor-pointer">
          <ReactSVG
            wrapper="span"
            src={getContentUrl(
              isSelected
                ? `/content/dam/wm/icons/controls/20x20/white/collapse.svg`
                : `/content/dam/wm/icons/controls/20x20/white/expand.svg`,
            )}
          />
        </span>
      )}
    </div>
  )
}

// // Note: React 19 no-longer supports propTypes. Leaving this for reference.
// FooterItemLegacy.propTypes = {
//   footerSubSection: PropTypes.string.isRequired,
//   column: PropTypes.object.isRequired,
//   updateFooterSubview: PropTypes.func,
// }

// // Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// FooterItemLegacy.defaultProps = {
//   updateFooterSubview: () => {},
// }

export default FooterItem
